export default __webpack_public_path__ + "static/media/fauna-docs-aside-expanded.5d32fa96.png";